/* 🤖 this file was generated by svg-to-ts */
export const iconMail: {
    name: 'mail';
    data: string;
} = {
    name: 'mail',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="16" viewBox="0 0 24 16"><path fill="#000" fill-rule="evenodd" d="m22.843 14.986-.003.003.06-.06a.5.5 0 0 1-.379.175l.088-.008a1 1 0 0 1-.068.008H1.479a.5.5 0 0 1-.319-.115.5.5 0 0 1-.18-.385l.007.087a1 1 0 0 1-.008-.085V1.374a.5.5 0 0 1 .064-.223l.01-.016a.49.49 0 0 1 .426-.239h21.042c.192 0 .341.099.425.236l.011.02a.4.4 0 0 1 .035.076.5.5 0 0 1 .03.146v13.23a.5.5 0 0 1-.122.326Zm-8.27-6.543-2.26 1.82a.5.5 0 0 1-.627 0l-2.221-1.79-6.625 5.63h18.329zM1.979 2.441v11.081l6.693-5.688zm20.042 0-6.656 5.364 6.656 5.711zm-.918-.545H2.896l9.103 7.336z"/></svg>`
};
